import { combineReducers } from '@fullstory/redux-util/utils/combineReducers';
import { MobileRecordingSettings } from '@fullstory/proto/fs/services/orgs';
import { MobileRecordingSettingsActions, MobileRecordingSettingsRequestActions } from './actions';
import { MobileRecordingSettingsTypes } from './types';
import { createRequestReducer } from '@fullstory/redux-util';

type settingsReducerState = MobileRecordingSettings | null;

export const settings = (
  state: settingsReducerState = null,
  action: MobileRecordingSettingsActions | MobileRecordingSettingsRequestActions,
): settingsReducerState => {
  switch (action.type) {
    case MobileRecordingSettingsTypes.Set: {
      return action.settings;
    }
    case MobileRecordingSettingsTypes.FetchSuccess:
    case MobileRecordingSettingsTypes.UpdateSuccess: {
      return action.data;
    }
  }
  return state;
};

const update = createRequestReducer<MobileRecordingSettings>()(
  MobileRecordingSettingsTypes.UpdateRequest,
  MobileRecordingSettingsTypes.UpdateSuccess,
  MobileRecordingSettingsTypes.UpdateFailure,
);

type MobileRecordingSettingsReducerState = {
  settings: ReturnType<typeof settings>;
  update: ReturnType<typeof update>;
};

export const mobileRecordingSettingsReducer = combineReducers<MobileRecordingSettingsReducerState>({
  settings,
  update,
});
